// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"Inspect_loadingIndicator__69bMJ"};